<template>
    <h6 v-if="title != null" :class="`${customclass}`" style="font-weight:700">{{ title }}</h6>
    <carousel ref="myCarousel" :wrapAround="wrapAround" transition="1000" :gap="count == 1 ? 100 : 15"
        :items-to-show="count" :pauseAutoplayOnHover="true" :snapAlign="'end'" :itemsToScroll="1"
        :breakpointMode="'carousel'" :autoplay="autoplay" :mouseDrag="mouseDrag" @slide-start="handleSlideStart"
        :breakpoints="computedBreakpoints" :class="{'inner':!paginationInner}">
        <template #slides>
            <Slide v-for="(slide, index) in slides == null ? 10 : slides" :key="slide" :class="{ 'clickable': clickable }">
                <div class="carousel__item">
                    <CustomerSliderImage v-if="imageType == 'slider'" :item="slide" :images="slide.assets"
                        :height="count == 2 ? 320 : 200" />
                    <template v-else-if="imageType == 'normal'">
                        <div class="w-100"
                            @click="clickable ? $router.push({ path: `${$route.path}/laden/${slide.urlname}` }) : null">
                            >
                            <div>
                                <img class="w-100 h-100" style="max-height:400px;"
                                    :src="`${cloudfrontUrl}${typeof slide == 'object' ? slide.gallerieAssets : slide}/${galleryName}`"
                                    alt="" :height="count == 2 ? 320 : count == 1 ? 637 : 200">
                            </div>
                            <v-row class="pt-1" v-if="imageDescription">
                                <v-col>
                                    <h3 class="text-left slide-title">{{ slide.name }}</h3>
                                    <div class="text-left slide-location">{{ slide.district ?? " "}}</div>
                                </v-col>
                                <v-col align="end">
                                    <v-btn size="small" variant="outlined" :ripple="false" prepend-icon="mdi-plus" @click.stop="() => follow()">{{$t('shop.profile.follow')}}</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template v-else-if="imageType == 'custom'">
                        <slot :item="slide" :index="index"></slot>
                    </template>
                </div>
            </Slide>
        </template>

        <template #addons>
            <navigation v-if="!showNavigation" />
            <pagination v-if="showPagination"/>
        </template>
    </carousel>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/dist/carousel.css'
import CustomerSliderImage from './CustomSliderImage.vue';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'


export default {
    name: 'App',
    props: {
        count: {
            type: Number,
            default: 3
        },
        customclass: {
            type: String,
        },
        title: {
            type: String,
            required: false,
        },
        slides: {
            type: Array,
            required: false
        },
        imageType: {
            type: String,
            default: 'slider'
        },
        wrapAround: {
            type: Boolean,
            default: false,
        },
        showPagination: {
            type: Boolean,
            default: false
        },
        paginationInner:{
            type:Boolean,
            default:false,
        },
        imageDescription: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Number,
            default: 0
        },
        mouseDrag: {
            type: Boolean,
            default: true
        },
        loadNewEntries: {
            type: Function,
            required: false
        },
        clickable: {
            type: Boolean,
            default: true
        },
        galleryName:{
            type:String,
            default: () => {
                return 'GALLERY_IPHONE6'
            }
        },
        follow:{
            type: Function,
            default: () => {
                return null
            }
        }
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
        CustomerSliderImage
    },

    computed: {
        showNavigation() {
            if (Array.isArray(this.slides)) {
                return this.count >= this.slides.length;
            }
            return true;
        },
        // showPagination() {
        //     if (Array.isArray(this.slides)) {
        //         return this.count >= this.slides.length;
        //     }
        //     return true;
        // },
        computedBreakpoints() {
            // return this.count === 3

            switch (this.count) {
                case 3:
                    return {
                        0: { itemsToShow: 1, snapAlign: 'center' },
                        600: { itemsToShow: 2, snapAlign: 'start' },
                        960: { itemsToShow: 3, snapAlign: 'start' }
                    }
                case 2:
                    return {
                        0: { itemsToShow: 1, snapAlign: 'center' },
                        600: { itemsToShow: 2, snapAlign: 'start' },
                    }
                case 1:
                    return {
                        0: { itemsToShow: 1, snapAlign: 'center' },
                    }

                default:
                    return {}
            }
        }
    },

    data() {
        return {
            cloudfrontUrl: process.env.VUE_APP_CLOUDFRONT_BASE_URL
        }
    },

    mounted() {
        this.$refs.myCarousel.updateBreakpointsConfig();
        // this.$refs.myCarousel.next();
        // this.$refs.myCarousel.next();
        // this.$refs.myCarousel.next();
    },
    methods: {
        handleSlideStart(data) {
            if (!this.loadNewEntries) return;
            if (data.slidingToIndex === data.slidesCount - 2) {
                this.loadNewEntries()
            }
        }
    },



}
</script>


<style>
.carousel__icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
}

@media only screen and (min-width: 1264px) {
    .inner .carousel__prev {
        left: -80px;
    }
    
   .inner .carousel__next {
        right: -80px;
    }
}



.carousel__prev,
.carousel__next {

    width: 60px;
    height: 60px;
    background-color: rgb(var(--v-theme-default)) !important;
    border-radius: 30px;
}

.carousel__pagination {
    bottom: 55px !important;
}

.carousel__pagination-button--active::after {
    background-color: white !important;
}

.carousel__pagination-button::after {
    width: 12px;
    height: 12px;
    border-radius: 6px;
    border: 2px white solid;
    background-color: transparent;
}

.slide-title {
    font-weight: 700;
    font-size: 12pt;
    margin-bottom: 2px;
}

.slide-location {
    font-size: 10pt;
    color: #535353;
    min-height: 20px;
}
</style>